var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.25 7.58252L9.20838 14.6242C8.31092 15.5217 8.31092 16.9767 9.20838 17.8742C10.1058 18.7717 11.5609 18.7717 12.4584 17.8742L19.5 10.8325C21.295 9.0376 21.295 6.12745 19.5 4.33252C17.7051 2.5376 14.795 2.5376 13 4.33252L5.95838 11.3742C3.26599 14.0666 3.26599 18.4318 5.95838 21.1242C8.65077 23.8166 13.016 23.8166 15.7084 21.1242L22.75 14.0825",
    stroke: "#202E5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attachFile.ab53b37d3714aa354ada9b9a77d48b5f.svg";
export { ForwardRef as ReactComponent };